import React, {useContext, useEffect, useState} from 'react';
import {CSVLink} from 'react-csv';
import moment from 'moment';

import {AppContext} from '../../AppModule/Context';
import {withExpertHomeContext} from '../../screens/ExpertHome/ExpertHomeContextProvider';
import CustomHooks from '../../customHooks';

import AiChatMsgComponent from './aiChatMsgComponent/aiChatMsgComponent';
import AiChatMsgImprovementComponent from './aiChatMsgImprovementComponent/aiChatMsgImprovementComponent';
import AiHandoffPendingChatMsgComponent from './aiHandoffPendingChatMsgComponent/aiHandoffPendingChatMsgComponent';
import AiHandoffStartedChatMsgComponent from './aiHandoffStartedChatMsgComponent/aiHandoffStartedChatMsgComponent';
import C2cMoneyTransactionChatComponent from './c2cMoneyTransactionChatComponent/c2cMoneyTransactionChatComponent';
import ChatEventIconComponent from './chatEventIconComponent/chatEventIconComponent';
import ChatListRowPillComponent from '../expertDashboardModule/chatCenter/chatListRowPillComponent';
import ChatRoomTaskOwnerComponent from './chatRoomTaskOwnerComponent/chatRoomTaskOwnerComponent';
import DropDownItem from '../common/genericComponents/dropDownV2/dropDownItem';
import EngagerInitiatorComponent from '../dagModule/engageInitiatorComponent';
import GetFileMessageComponent from '../fileMessageComponents/getFileMessageComponent';
import GetVoiceMsgComponent from '../audioMessagesComponents/getVoiceMsgComponent';
import ImageViewDownloadComponent from '../common/genericComponents/redesign/imageViewDownloadComponent/imageViewDownloadComponent';
import InfoComponentV2 from '../common/genericComponents/redesign/infoComponentV2/infoComponentV2';
import MentorListeningRoomInitializer from './mentorListeningRoomInitializer';
import MentorNotes from './mentorNotes';
import MentorPillComponent from '../common/genericComponents/redesign/mentorPillComponent/mentorPillComponent';
import MoveChatPopup from './moveChatPopup';
import MultiStateButton from '../common/genericComponents/redesign/multiStateButton/multiStateButton';
import ParticipantChatNameComponent from './participantChatNameComponent';
import ParticipantChatPillComponent from './participantChatPillComponent';
import PaymentRequestInitiatorComponent from '../paymentRequestComponent/paymentRequestInitiatorComponent';
import PillComponent from '../common/genericComponents/pillComponent/pillComponent';
import SendFileComponent from './sendFileComponent';
import SendVoiceMsgComponent from '../../components/audioMessagesComponents/sendVoiceMsgComponent';
import ThreedMentorSelect from './threedMentorSelect';
import ThreedWrapper from '../threedComponents/threedWrapper';
import TitleComponentV2 from '../common/genericComponents/redesign/titleComponentV2/titleComponentV2';
import ToolTipComponent from '../common/genericComponents/toolTipComponent';
import TypingComponent from '../common/genericComponents/typingComponent';
import UpgradeComponent from '../common/genericComponents/redesign/upgradeComponent/upgradeComponent';

import expertHomeService from '../../services/expertHomeService';
import hybridStorageService from '../../services/hybridStorageService';
import indexDbService from '../../services/indexDbService';
import UtilServices from '../../services/utilsService';
import utilsService from '../../services/utilsService';

import emailIcon from '../../../src/assets/svg/email-blue.svg';
import fileSendIcon from '../../../src/assets/svg/file-send.svg';
import info from '../../../src/assets/svg/money_sq.svg';
import ContactFormIcon from '../../assets/svgComponents/LeftNavigationIcons/ContactFormIcon';
import EnvelopeArrowIcon from '../../assets/svgComponents/LeftNavigationIcons/EnvelopeArrowIcon';
import LockIcon from '../../assets/svgComponents/LockIcon';
import loadMoreIcon from '../../../src/assets/svg/upArrow.svg';
import MenuThreeDotsIcon from '../../assets/svgComponents/LeftNavigationIcons/MenuThreeDotsIcon';
import NotificationAiBotIcon from '../../assets/svgComponents/NotificationAiBotIcon';
import notesIcon from '../../../src/assets/svg/Group 231331.svg';
import SessionInstanceChatComponentLazy from '../sessionInstanceChatComponent/sessionInstanceChatComponentLazy';
import shareScreenIcon from '../../../src/assets/svg/share-screen-no-back-icon.svg';
import threedIcon from '../../../src/assets/svg/icons/3d-icon.svg';
import UnlockIcon from '../../assets/svgComponents/UnlockIcon';
import VideoMessageComponentWrapper from '../videoMessageComponent/videoMessageComponentWrapper';
import VoiceMsgUploadingLoader from '../audioMessagesComponents/voiceMsgUploadingLoader/voiceMsgUploadingLoader';

import VIDABOO_CONSTANTS from '../../config/consts';

const POPUP_TYPES = {
  ENGAGER: 'ENGAGER',
  PAYMENT: 'PAYMENT',
  SHARE: 'SHARE',
  THREED: 'THREED',
  NOTES: 'NOTES',
  FILE: 'FILE',
  MOVE_CHAT: 'MOVE_CHAT',
};

const MentorChatBoxComponent = (props) => {
  const context = useContext(AppContext);
  const prevIsWsConnected = CustomHooks.usePrevious(props.isWsConnected);

  let extraFeatures = context.currentUser.extras;
  if (context.accountDto && context.accountDto.isActive) {
    extraFeatures = context.accountDto.extras;
  }
  const threedEnabled =
    (extraFeatures && extraFeatures['THREED']) ||
    (context.billingPlanDto?.planEnabledFeatures &&
      context.billingPlanDto?.planEnabledFeatures['THREED'] > 0);

  const moneyTransferEnabled =
    (extraFeatures && extraFeatures[VIDABOO_CONSTANTS.EXTRAS.MONEY_TRANSFER]) ||
    (context.billingPlanDto?.planEnabledFeatures &&
      context.billingPlanDto?.planEnabledFeatures[
        VIDABOO_CONSTANTS.EXTRAS.MONEY_TRANSFER
      ] > 0);
  const chatboxDivId = utilsService.getFormattedId(
    VIDABOO_CONSTANTS.ID_PREFIX.CHATBOX,
    props.chatRoomDto.roomId,
  );
  const showParticipantInfo = props.isGroupChatRoom || props.isTeamChatRoom;

  const [csvData, setCsvData] = useState([]);
  const [threedFilePresent, showThreedFilePresent] = useState(false);
  const [selected3DFile, setSelected3File] = useState('');
  // const [
  //   deleteConnectToPeerListeningRoom,
  //   setDeleteConnectToPeerListeningRoom,
  // ] = useState();
  const [personalNotes, setPersonalNotes] = React.useState({});

  // Show image popup states
  const [srcImagePopup, setSrcImagePopup] = useState();
  const [showImagePopup, setShowImagePopup] = useState(false);
  const [meta, setMeta] = useState({});
  const [isPermittedToWriteChatRoom, setIsPermittedToWriteChatRoom] =
    useState(false);
  const [isPermittedToReadChatRoom, setIsPermittedToReadChatRoom] =
    useState(false);
  const [showTooltipComponent, setShowTooltipComponent] = useState([]);
  const [widgetDto, setWidgetDto] = useState({});
  const [widgetName, setWidgetName] = useState('');
  const [roomExtendedMentorDto, setRoomExtendedMentorDto] = useState(null);
  const [myRoomExtendedMentorDto, setMyRoomExtendedMentorDto] = useState({});
  const [popupType, setPopupType] = useState(null);
  const [showWsInfo, setShowWsInfo] = useState(false);
  const [showSendEmailPopUp, setShowSendEmailPopUp] = useState(false);
  const [hoveredMessageIndex, setHoveredMessageIndex] = useState(null);
  const [showChatRowOptionsMenu, setShowChatRowOptionsMenu] = useState(false);
  const [showHeaderOptions, setShowHeaderOptions] = useState(false);
  const [showVoiceMessageUploadingLoader, setShowVoiceMessageUploadingLoader] =
    useState(false);
  const [currentlyActiveOoniChatMsg, setCurrentlyActiveOoniChatMsg] =
    useState(null);
  const [selectedAiChatMsgForImprovement, setSelectedAiChatMsgForImprovement] =
    useState(null);
  const [showTakeControlInfo, setShowTakeControlInfo] = useState(true);
  const isOoniEnabledForMentor = expertHomeService.getIsOoniEnabledForMentor(
    widgetDto,
    myRoomExtendedMentorDto?.mentorDto?.mentorId,
  );

  let csvName = props.roomName + '.csv';
  const showTakeOwnershipBtn =
    !props.chatRoomDto.taskOwnerMentorId &&
    (props.isTeamChatRoom ||
      (!props.isGroupChatRoom && isOoniEnabledForMentor));
  const showGiveBackControlBtn =
    (props.isTeamChatRoom ||
      (!props.isGroupChatRoom && isOoniEnabledForMentor)) &&
    props.chatRoomDto.taskOwnerMentorId;
  const isTaskOwnerLocked = props.chatRoomDto.isTaskOwnerLocked;

  useEffect(() => {
    if (
      prevIsWsConnected !== undefined &&
      !prevIsWsConnected &&
      props.isWsConnected
    ) {
      if (!showWsInfo) setShowWsInfo(true);
    } else {
      setShowWsInfo(false);
    }
  }, [props.isWsConnected]);

  useEffect(() => {
    const currentlyActiveOoniChatMsg = [...props.chatBoxMessages]
      .reverse()
      .find(
        (chatMessageDto) =>
          chatMessageDto.senderObjectType ===
            VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.OONI_AI &&
          expertHomeService.getOoniAiAction(chatMessageDto) ===
            VIDABOO_CONSTANTS.OONI_AI_ACTIONS.COMPLETION_PENDING,
      );
    setCurrentlyActiveOoniChatMsg(currentlyActiveOoniChatMsg);
  }, [props.chatBoxMessages]);

  useEffect(() => {
    if (props.chatRoomDto) {
      const {widgetDto, extendedMentorDto: myRoomExtendedMentorDto} =
        expertHomeService.getWidgetDtoExMentorDtoUsingMentorId(
          props.expertHomeContext.widgetDtos,
          props.myParticipantId,
        );

      const roomExtendedMentorDto =
        expertHomeService.getWidgetDtoExMentorDtoByTeamMentorIdOrMentorId(
          props.expertHomeContext.widgetDtos,
          props.chatRoomDto.ownerObjectId,
        )?.extendedMentorDto;

      const {write, read} = expertHomeService.getMentorAccessRights(
        VIDABOO_CONSTANTS.MENTOR_ACCESS_RIGHT_TYPES.CHAT_ROOM,
        {
          chatRoom: props.chatRoomDto,
          participantId: props.myParticipantId,
          currentUserId: context.currentUser.userId,
          isAccountManager: context.isAccountManager,
          widgetDtos: props.expertHomeContext.widgetDtos,
          users: context.accountDto?.usersCtrlMap || {},
        },
      );
      const isPermittedToWriteChatRoom = write;
      const isPermittedToReadChatRoom = read;

      setWidgetName(widgetDto.widgetAppCtrlDto.name);
      setRoomExtendedMentorDto(roomExtendedMentorDto);
      setMyRoomExtendedMentorDto(myRoomExtendedMentorDto);
      setWidgetDto(widgetDto);
      setIsPermittedToWriteChatRoom(isPermittedToWriteChatRoom);
      setIsPermittedToReadChatRoom(isPermittedToReadChatRoom);
      setShowSendEmailPopUp(!props.isGroupChatRoom);
    }
  }, [props.chatRoomDto]);

  useEffect(() => {
    const textAreaRef = props.chatTextAreaRef.current;
    if (textAreaRef) {
      textAreaRef.rows = 1;
      if (props.messageToSend?.length) {
        const textAreaLineHeight = parseInt(
          getComputedStyle(textAreaRef).lineHeight,
          10,
        );
        const totalLines = textAreaRef.scrollHeight / textAreaLineHeight;
        const totalRows = Math.min(
          VIDABOO_CONSTANTS.TEXT_AREA_MAX_ROWS,
          Math.floor(totalLines),
        );
        textAreaRef.rows = totalRows;
      }
      textAreaRef.scrollTop = textAreaRef.scrollHeight;
    }
  }, [props.messageToSend]);

  useEffect(() => {
    // this ensures that text is cleared incase the input textbox disapepars and appears: eg in changeOnwershipFlow and textbox has at least 3 lines of text
    const event = {target: {}};
    event.target.value = '';
    props.onTextareaChange(event);
  }, [showTakeOwnershipBtn]);

  useEffect(() => {
    window.addEventListener('dragenter', handleDragEnter);
    window.addEventListener('dragleave', handleDragLeave);

    if (utilsService.isMobileDevice()) {
      let element = document.getElementById('et-n-flag-widget-container-div');
      if (element) element.style.bottom = '155px';
    }

    return () => {
      window.removeEventListener('dragenter', handleDragEnter);
      window.removeEventListener('dragleave', handleDragLeave);

      if (utilsService.isMobileDevice()) {
        let element = document.getElementById('et-n-flag-widget-container-div');
        if (element) element.style.bottom = '55px';
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const cfChatCenter =
    context.currentUser?.controlledFeaturesDto?.backOffice['chatCenter'];

  useEffect(() => {
    if (props.scrollToSelectedMessage) {
      UtilServices.goToMessage(props.scrollToSelectedMessage);
    }
  }, [props.scrollToSelectedMessage]);

  useEffect(() => {
    const isDismissed = hybridStorageService.existsInLocal(
      VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS.TAKE_OWNERSHIP_OF_CHAT_ROOM,
    );
    setShowTakeControlInfo(!isDismissed);
  }, [props.myParticipantId]);

  const handleTakeControlInfoDismiss = () => {
    const success = hybridStorageService.saveToLocal(
      VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS.TAKE_OWNERSHIP_OF_CHAT_ROOM,
      'user',
      context.currentUser.userId,
    );

    if (success) {
      setShowTakeControlInfo(false);
    }
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    var dt = e.dataTransfer;
    if (
      dt.types &&
      (dt.types.indexOf
        ? dt.types.indexOf('Files') !== -1
        : dt.types.contains('Files'))
    ) {
      props.onFileDrag(true);
    }
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    if (!e.fromElement) {
      props.onFileDrag(false);
    }
  };

  const setDataForImagePopup = (data) => {
    setSrcImagePopup(data.srcImagePopup);
    setShowImagePopup(data.showImagePopup);
    setMeta(data.meta);
  };

  const updatePopupType = (newPopupType) => {
    if (newPopupType !== POPUP_TYPES.FILE && props.showSendFileComponent) {
      props.openCloseSendFileComponent(false, null);
    }
    //toggle case
    if (newPopupType === popupType) {
      setPopupType(null);
    } else {
      setPopupType(newPopupType);
    }
  };

  const presentFile = (file) => {
    showThreedFilePresent(true);
    updatePopupType(null);
    setSelected3File(file);
    context.setThreedContainerSize(VIDABOO_CONSTANTS.ACTIVE_3D_SIZE.MEDIUM);
  };

  const cancelPresent3d = () => {
    console.debug('cancelPresent3d');
    removeDbListeners();
    showThreedFilePresent(false);
  };
  const updateCsvForDownload = () => {
    // console.debug("download chat is called", this.state.chatBoxMessages);
    let csvData = [];
    props.chatBoxMessages.forEach((msg) => {
      // console.debug(msg, 'Message');
      let messageText = msg.messageText;
      if (msg.subType === VIDABOO_CONSTANTS.CHAT_SUBTYPES.INFO_MESSAGE) {
        let meta = expertHomeService.getMetaDataFromChatMessageDto(msg);
        if (meta.version !== 'v2') {
          messageText = `Name: ${meta.senderFirstName},\nEmail: ${
            meta.email
          }\n${meta.phoneNumber ? 'Phone: ' + meta.phoneNumber : ''}\n${
            meta.content && meta.content.trim() !== ''
              ? 'Description: ' + meta.content
              : ''
          }`;
        } else {
          let msgText = '';
          meta.content.forEach((formField) => {
            if (formField.title && formField.answers) {
              msgText += `${formField.title}: ${formField.answers},\n`;
            }
          });
          messageText = msgText.slice(0, -2);
        }
      }
      const peerName = props.chatRoomDto?.chatRoomPeerInfoDto?.peerName;

      csvData.push({
        Sender:
          msg.fromPeer === true
            ? peerName
              ? peerName
              : props.peerName
            : props.currentUser.firstName + ' ' + props.currentUser.lastName,
        Date: msg.sendTimeFormatted,
        Message: messageText,
        MessageType: utilsService.getTextByChatSubType(msg.subType),
      });
    });
    setCsvData(csvData);
  };

  // const trialFeaturesEnabled =
  //   new Date().getTime() - props.currentUser.createdTime <=
  //   7 * VIDABOO_CONSTANTS.COMMON_PERIODS.DAY;

  const toggleTooltip = (id, enter) => {
    const showTooltipComponentNew = [...showTooltipComponent];
    showTooltipComponentNew[id] = enter;
    setShowTooltipComponent(showTooltipComponentNew);
  };

  const removeDbListeners = () => {
    console.debug('removeDbListeners');
    indexDbService.removeListeners();
  };

  const openClose3DRequestPopup = () => {
    if (popupType === POPUP_TYPES.THREED) {
      removeDbListeners();
    }

    if (!threedFilePresent) {
      updatePopupType(POPUP_TYPES.THREED);
    }
  };

  const handlePersonalNoteChange = (id, value) => {
    const pNotes = {...personalNotes};
    pNotes[props.peerUserId] = value;
    setPersonalNotes(pNotes);
  };

  const savePersonalNote = () => {
    const pNotes = personalNotes;

    // Initiate message to send in chat also
    props.sendMessage(
      pNotes[props.peerUserId],
      VIDABOO_CONSTANTS.CHAT_SUBTYPES.NOTES_MESSAGE,
    );
    updatePopupType(null);

    // Clear message now
    pNotes[props.peerUserId] = '';
    setPersonalNotes(pNotes);
  };
  const openCloseSendFileComponent = () => {
    props.openCloseSendFileComponent(!props.showSendFileComponent, null);
    if (props.showSendFileComponent) {
      updatePopupType(null);
    } else {
      updatePopupType(POPUP_TYPES.FILE);
    }
  };

  const onMentorSelected = (newTaskOwnerMentorId) => {
    props.handleTransitionChatRoomOwnership(
      props.chatRoomDto,
      newTaskOwnerMentorId,
    );
  };
  const onTransitionToMentorChat = (
    mentorId,
    transitionChatRoomCloneRecipe,
  ) => {
    props.handleTransitionToMentorChat(
      mentorId,
      props.chatRoomDto,
      transitionChatRoomCloneRecipe,
    );
  };

  const doWhenMouseHoveredOnMessage = (e, index) => {
    if (
      !e.target.classList.contains('et-time') &&
      !e.target.classList.contains('et-chat-status')
    ) {
      setHoveredMessageIndex(index);
    }
  };
  const doWhenMouseLeavesMessage = () => {
    setHoveredMessageIndex(null);
  };

  const onTakeOwnershipBtnClick = () => {
    if (
      widgetDto?.widgetAppCtrlDto?.widgetPrivacyMode ===
      VIDABOO_CONSTANTS.WIDGET_PRIVACY_MODES.HALF_PRIVATE
    ) {
      updatePopupType(POPUP_TYPES.MOVE_CHAT);
    } else {
      props.handleTransitionChatRoomOwnership(
        props.chatRoomDto,
        props.myParticipantId,
      );
    }
  };

  const onGiveBackControlBtnClick = () => {
    props.handleTransitionChatRoomOwnership(props.chatRoomDto, null);
  };

  const onToggleTaskOwnerLock = () => {
    props.handleTaskOwnerLockChange(
      props.chatRoomDto.roomId,
      isTaskOwnerLocked,
    );
  };

  const messageOptionsMenu = (
    index,
    message,
    isPeer = false,
    flipMenuDirection = false,
  ) =>
    message.chatMessageId &&
    message.chatMessageId === currentlyActiveOoniChatMsg?.chatMessageId ? (
      <></>
    ) : (
      <div
        onMouseLeave={() => setShowChatRowOptionsMenu(false)}
        className={'et-chatting-chat-row-options-container'}>
        <div
          onClick={() => {
            setHoveredMessageIndex(index);
            setShowChatRowOptionsMenu(true);
          }}
          className={
            hoveredMessageIndex === index
              ? `et-chatting-chat-row-options ${!isPeer ? 'et-chatting-chat-row-options-sender' : ''}`
              : 'et-chatting-chat-row-options-hidden'
          }>
          <MenuThreeDotsIcon />
        </div>
        {hoveredMessageIndex === index && showChatRowOptionsMenu && (
          <div
            className={`et-chatting-chat-row-options-menu-wrapper ${isPeer && flipMenuDirection ? 'et-chatting-chat-row-options-menu-wrapper-sender-menu-flipped-peer' : ''} ${!isPeer ? (flipMenuDirection ? 'et-chatting-chat-row-options-menu-wrapper-sender-menu-flipped' : 'et-chatting-chat-row-options-menu-wrapper-sender') : ''}`}>
            <div className="et-chatting-chat-row-options-menu-container ">
              <DropDownItem
                isSelected={false}
                showBoldText={false}
                btnText=""
                LeftComponent={null}
                RightComponent={
                  <div className="et-chatting-chat-row-options-menu-text">
                    Delete message
                  </div>
                }
                onClick={() => {
                  context.setNotificationPopUpData({
                    notificationTxt:
                      'Are you sure you would like to delete this message?',
                    notificationType:
                      VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
                    rejectBtnTxt: 'Delete',
                    rejectBtnFunc: () => {
                      props.deleteMessageById(
                        message.messageId,
                        message.messageTag,
                        () => {},
                        (failureMessage) => {
                          context.setNotificationPopUpData({
                            notificationTxt:
                              failureMessage ??
                              'Could not delete this message at the moment!',
                            notificationType:
                              VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES
                                .WARNING,
                            closeBtnTxt: 'Close',
                            closeBtnFunc: () => {
                              context.closeNotificationPopUp();
                            },
                          });
                          context.setShowNotificationPopUp(true);
                        },
                      );
                      context.closeNotificationPopUp();
                    },
                    closeBtnTxt: 'Close',
                    closeBtnFunc: () => {
                      context.closeNotificationPopUp();
                    },
                  });
                  context.setShowNotificationPopUp(true);
                }}
              />
              {message.subType === VIDABOO_CONSTANTS.CHAT_SUBTYPES.OONI_AI &&
                expertHomeService.getOoniAiAction(message) ===
                  VIDABOO_CONSTANTS.OONI_AI_ACTIONS.COMPLETION_SUCCESS && (
                  <DropDownItem
                    isSelected={false}
                    showBoldText={false}
                    btnText=""
                    LeftComponent={null}
                    RightComponent={
                      <div
                        className={`et-chatting-chat-row-options-menu-text-ooni ${
                          selectedAiChatMsgForImprovement?.chatMessageId
                            ? 'et-chatting-chat-row-options-menu-text-ooni-disabled'
                            : ''
                        }`}>
                        Improve answer
                      </div>
                    }
                    onClick={() => {
                      if (!selectedAiChatMsgForImprovement?.chatMessageId) {
                        setSelectedAiChatMsgForImprovement(message);
                      }
                    }}
                  />
                )}
            </div>
          </div>
        )}
      </div>
    );

  return (
    <React.Fragment>
      {selectedAiChatMsgForImprovement && (
        <AiChatMsgImprovementComponent
          context={context}
          messageObj={selectedAiChatMsgForImprovement}
          onClose={() => setSelectedAiChatMsgForImprovement(null)}
        />
      )}
      <MentorListeningRoomInitializer
        peerUserId={props.peerUserId}
        currentUser={context.currentUser}
      />
      <div className="et-cc-chatting-head">
        <div className="et-cc-ch-left">
          <ChatListRowPillComponent
            hidePersonImage
            isAccountManager={context.isAccountManager}
            isDisabled={props.isTakeOwnershipFlowRunning}
            isGroupChatRoom={props.isGroupChatRoom}
            isTeamChatRoom={props.isTeamChatRoom}
            chatRoom={props.chatRoomDto}
            myParticipantId={props.myParticipantId}
            myRoomExtendedMentorDto={myRoomExtendedMentorDto}
            participantsInfo={props.chatRoomDto.participantsInfo}
            roomExtendedMentorDto={roomExtendedMentorDto}
            widgetDto={widgetDto}
            onMentorSelected={onMentorSelected}
            onTransitionToMentorChat={onTransitionToMentorChat}
          />
          <div className="et-cc-chatting-head-label">
            You are chatting with:
          </div>
          {isPermittedToWriteChatRoom ? (
            <>
              <i
                className="et-cc-chatting-head-i fas fa-pencil-alt"
                onClick={() => props.handleRoomNameInput()}
              />

              <form
                className="et-ccchs-form"
                onSubmit={(event) => {
                  event.preventDefault();
                  props.handleRoomNameSubmit();
                }}>
                <input
                  dir="auto"
                  placeholder="Enter Peer Name"
                  className="et-cc-chatting-head-span"
                  ref={props.peerNameRef}
                  type="text"
                  value={props.roomName || ''}
                  onChange={(event) => props.handleRoomName(event)}
                  onBlur={props.handleRoomNameSubmit}
                />
                {props.roomNameWarn && (
                  <div
                    className={`et-ccchs-warn ${
                      props.roomNameWarnTxt ===
                      'Peer Name updated successfully!'
                        ? 'et-ccchsw-green'
                        : props.roomNameWarnTxt === ''
                          ? ''
                          : 'et-ccchsw-red'
                    }`}>
                    {props.roomNameWarnTxt}
                  </div>
                )}
              </form>
            </>
          ) : (
            <div className="et-cc-chatting-head-span">
              {props.roomName || ''}
            </div>
          )}
        </div>{' '}
        <div
          className="et-cc-ch-right"
          onClick={() => setShowHeaderOptions(!showHeaderOptions)}
          onMouseLeave={() => setShowHeaderOptions(false)}>
          {<MenuThreeDotsIcon />}
          {showHeaderOptions && (
            <div className="et-cc-ch-right-menu-wrapper">
              <div className="et-cc-ch-right-menu-container">
                <div
                  onMouseEnter={() => {
                    updateCsvForDownload();
                    // toggleTooltip('downloadChat', true);
                  }}
                  onMouseLeave={() => {
                    //toggleTooltip('downloadChat', false);
                  }}>
                  {/* {showTooltipComponent['downloadChat'] && (
                    <ToolTipComponent
                      toolTipTxt={'Download chat content and store locally'}
                      toolTipPosition="left" // postion : top, right, bottom, left
                    />
                  )} */}
                  <CSVLink
                    style={{textDecoration: 'none'}}
                    data={csvData}
                    filename={csvName}
                    target="_blank"
                    className="et-chat-download">
                    <DropDownItem
                      isSelected={false}
                      showBoldText={false}
                      btnText="Download conversation"
                      LeftComponent={null}
                      RightComponent={null}
                      onClick={() => {
                        //  setShowHeaderOptions(false);
                      }}
                    />
                  </CSVLink>
                </div>
                <DropDownItem
                  isSelected={false}
                  showBoldText={false}
                  btnText=""
                  LeftComponent={null}
                  RightComponent={
                    <div className="et-chatting-chat-row-options-menu-text">
                      Delete the entire conversation
                    </div>
                  }
                  onClick={() => {
                    context.setNotificationPopUpData({
                      notificationTxt:
                        'Are you sure you would like to delete the entire conversation?',
                      notificationType:
                        VIDABOO_CONSTANTS.POPUP_NOTIFICATION_TYPES.WARNING,
                      rejectBtnTxt: 'Delete',
                      rejectBtnFunc: () => {
                        props.deleteConversation();
                        context.closeNotificationPopUp();
                      },
                      closeBtnTxt: 'Close',
                      closeBtnFunc: () => {
                        context.closeNotificationPopUp();
                      },
                    });
                    context.setShowNotificationPopUp(true);
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
      {(!props.isWsConnected || showWsInfo) && (
        <div className="et-cc-socket-info-wrap">
          <InfoComponentV2
            isWarningUI={!props.isWsConnected}
            showAnim
            titleTxt={
              props.isWsConnected
                ? 'Connection restored'
                : 'Connection unstable'
            }
            subTitleTxt={
              props.isWsConnected
                ? "Let's pick up right where we left off"
                : 'Hang tight while we reconnect'
            }
            btnTxt={props.isWsConnected ? 'Refresh' : null}
            onClick={() => {
              setShowWsInfo(false);
              props.reloadChatBoxMessages();
            }}
          />
        </div>
      )}
      <div
        className={`et-chatting-box ${
          props.showSendFileComponent ||
          popupType === POPUP_TYPES.NOTES ||
          popupType === POPUP_TYPES.THREED ||
          showImagePopup
            ? ' blur'
            : ''
        } ${chatboxDivId}`}
        id={chatboxDivId}
        key={'btn-' + chatboxDivId}>
        {props.showLoadMore && (
          <button
            className="et-chat-history-btn"
            onClick={() => props.getMessagesHistory(props.chatRoomDto.roomId)}>
            <img
              className="et-chat-history-btn-img"
              src={loadMoreIcon}
              alt=""
            />
            {/* <i className="fas fa-arrow-up"></i> Load more{' '}
            <i className="fas fa-arrow-up"></i> */}
          </button>
        )}
        {props.chatBoxMessages.map((message, index) => {
          const messageDate = moment(message.sendTime);
          let formattedDate = messageDate.format('D MMMM HH:mm');
          const formattedYear = new Date(message.sendTime).getFullYear();
          const currentYear = new Date().getFullYear();
          if (formattedYear < currentYear) {
            formattedDate = moment(message.sendTime).format(
              'D MMMM YYYY HH:mm',
            );
          }
          const isMsgSendByOoni =
            message.senderObjectType ===
            VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.OONI_AI;

          if (
            message.subType === VIDABOO_CONSTANTS.CHAT_SUBTYPES.INFO_MESSAGE ||
            message.subType === VIDABOO_CONSTANTS.CHAT_SUBTYPES.OB_EMAIL ||
            isMsgSendByOoni
          ) {
            message.parsedMetaData =
              expertHomeService.getMetaDataFromChatMessageDto(message);
            if (message.parsedMetaData.version === 'v2') {
              message.parsedMetaData.content = Object.values(
                message.parsedMetaData.content,
              );
            }
          }

          const participantName =
            showParticipantInfo &&
            props.chatRoomDto.participantsInfo[message.senderObjectId]
              ?.participantName
              ? props.chatRoomDto.participantsInfo[message.senderObjectId]
                  .participantName
              : null;

          return message.fromPeer ? (
            <div
              key={message.chatMessageId + '_' + message.sendTime}
              className={`et-chatting-chat-row-sender-name-msg-wrap ${
                message.subType ===
                VIDABOO_CONSTANTS.CHAT_SUBTYPES.NOTES_MESSAGE
                  ? 'et-chatting-chat-peer-private-note'
                  : ''
              } ${showParticipantInfo ? 'et-chatting-chat-with-participant-name' : ''}`}>
              {showParticipantInfo &&
                ![VIDABOO_CONSTANTS.CHAT_SUBTYPES.NOTES_MESSAGE].includes(
                  message.subType,
                ) && (
                  <ParticipantChatPillComponent
                    assistantName={
                      roomExtendedMentorDto?.mentorDto?.appControlDto
                        ?.assistantName
                    }
                    isOoniPill={isMsgSendByOoni}
                    showMentorEmail={context.isAccountManager}
                    extendedMentorDto={
                      props.chatRoomDto.participantsInfo[message.senderObjectId]
                        ?.extendedMentorDto
                    }
                    widgetName={widgetName}
                  />
                )}
              <div
                id={message.chatMessageId}
                className={`${
                  message.subType ===
                  VIDABOO_CONSTANTS.CHAT_SUBTYPES.TEXT_MESSAGE
                    ? 'et-chatting-chat-row et-chat-left-blue'
                    : 'et-chatting-chat-row et-chat-left'
                } ${
                  message.subType === VIDABOO_CONSTANTS.CHAT_SUBTYPES.OONI_AI
                    ? 'et-chatting-chat-row-ooni'
                    : ''
                }`}
                onMouseEnter={(e) => doWhenMouseHoveredOnMessage(e, index)}
                onMouseLeave={doWhenMouseLeavesMessage}>
                <div
                  className={
                    message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.NOTES_MESSAGE
                      ? 'et-chatting-chat-peer-private-note-wrapper'
                      : 'et-chatting-chat-general-message-wrapper'
                  }>
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.AUDIO_MESSAGE && (
                    <React.Fragment>
                      <GetVoiceMsgComponent
                        align="left"
                        voiceMsgId={message.metaData}
                        chatMessageId={message.chatMessageId}
                        participantName={participantName}
                      />
                      <div className="et-chat-status">
                        <span className="et-time">{formattedDate}</span>
                      </div>
                    </React.Fragment>
                  )}
                  {(message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.FILE_MESSAGE ||
                    message.subType ===
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.IMAGE_MESSAGE) && (
                    <React.Fragment>
                      <GetFileMessageComponent
                        chatMessageId={message.chatMessageId}
                        mediaMessageMeta={message.metaData}
                        participantName={participantName}
                        align={'left'}
                        setDataForImagePopup={setDataForImagePopup}
                        key={message.sendTime} // solves wrong-id bug. Keep this!!
                      />
                      <div className="et-chat-status">
                        <span className="et-time">{formattedDate}</span>
                      </div>
                    </React.Fragment>
                  )}
                  {[
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.WHATSAPP_MESSAGE,
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.MESSENGER_MESSAGE,
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.PHONE_MESSAGE,
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.VIDEOCHAT_MESSAGE,
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.SCHEDULE_MEETING,
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.CUSTOM_LINK_MESSAGE,
                  ].includes(message.subType) && (
                    <ChatEventIconComponent
                      eventType={message.subType}
                      formattedDate={formattedDate}
                      participantName={participantName}
                      handleClick={
                        message.subType ===
                        VIDABOO_CONSTANTS.CHAT_SUBTYPES.SCHEDULE_MEETING
                          ? () => props.openSchedule(message.metaData)
                          : null
                      }
                    />
                  )}
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.MONEY_TRANSACTION && (
                    <React.Fragment>
                      <C2cMoneyTransactionChatComponent
                        chatMessageDto={message}
                      />
                      <div className="et-chat-status">
                        <span className="et-time">{formattedDate}</span>
                      </div>
                    </React.Fragment>
                  )}
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.INFO_MESSAGE &&
                    message.parsedMetaData.version !== 'v2' && (
                      <div className="et-chat-left-wide-info">
                        <div className="et-chat-left-wi-icon-wrap">
                          <div className="et-chat-left-special-item et-chat-left-special-item-notes">
                            <img
                              className="et-cls-img"
                              src={info}
                              alt="video"
                            />
                          </div>

                          <div className="et-chat-status et-chat-wi-status">
                            <span className="et-time">{formattedDate}</span>
                          </div>
                        </div>
                        {message.parsedMetaData && (
                          <div className="et-chat-left-info-msg-wrap">
                            <div className="et-clim-item">
                              Name: {message.parsedMetaData?.senderFirstName}
                            </div>
                            <div className="et-clim-item">
                              Email: {message.parsedMetaData?.email}
                            </div>
                            {message.parsedMetaData?.phoneNumber && (
                              <div className="et-clim-item">
                                Phone: {message.parsedMetaData?.phoneNumber}
                              </div>
                            )}
                            {message.parsedMetaData?.content &&
                              message.parsedMetaData?.content.trim() && (
                                <div className="et-clim-item">
                                  Message:{' '}
                                  {message.parsedMetaData?.content.trim()}
                                </div>
                              )}
                          </div>
                        )}
                      </div>
                    )}
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.INFO_MESSAGE &&
                    message.parsedMetaData.version === 'v2' && (
                      <React.Fragment>
                        <div className="et-chat-left-special-item-schedule-v2">
                          {showParticipantInfo && (
                            <ParticipantChatNameComponent
                              participantName={
                                props.chatRoomDto.participantsInfo[
                                  message.senderObjectId
                                ]?.participantName
                              }
                            />
                          )}
                          {message.parsedMetaData && (
                            <div className="et-chat-n-left-info-msg-wrap">
                              <div className="et-chat-txt-form">
                                <div className="et-cci-img-wrap ">
                                  <ContactFormIcon fillColor="#2961fa" />
                                </div>
                                Form
                              </div>
                              {message.parsedMetaData.content.map(
                                (messageObj, index) => {
                                  const isAnswerExist =
                                    messageObj.title && messageObj.answers;
                                  return (
                                    <React.Fragment key={index}>
                                      {isAnswerExist && (
                                        <React.Fragment>
                                          <div className="et-chat-clim-item">
                                            <div className="et-chat-item-title">
                                              {messageObj.title + ':'}
                                            </div>
                                            {messageObj.questionType ===
                                            VIDABOO_CONSTANTS.QUESTION_TYPE
                                              .CONSENT ? (
                                              <PillComponent
                                                pillTxt={messageObj.answers}
                                                pillType={
                                                  VIDABOO_CONSTANTS.PILL_TYPES
                                                    .BETA
                                                }
                                              />
                                            ) : (
                                              <div className="et-chat-item-answer">
                                                {messageObj.answers}
                                              </div>
                                            )}
                                          </div>
                                        </React.Fragment>
                                      )}
                                    </React.Fragment>
                                  );
                                },
                              )}
                            </div>
                          )}
                        </div>
                        <div className="et-chat-status">
                          <span className="et-time">{formattedDate}</span>
                        </div>
                      </React.Fragment>
                    )}
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.TEXT_MESSAGE && (
                    <React.Fragment>
                      {participantName && (
                        <ParticipantChatNameComponent
                          participantName={participantName}
                        />
                      )}
                      <span>{props.getTextMessage(message.messageText)}</span>
                      <div className="et-chat-status">
                        <span className="et-time">{formattedDate}</span>
                      </div>
                    </React.Fragment>
                  )}
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.OONI_AI && (
                    <AiChatMsgComponent
                      showAnimatedBorder={
                        selectedAiChatMsgForImprovement?.chatMessageId ===
                        message.chatMessageId
                      }
                      chatMessageDto={message}
                      chatRoomDto={props.chatRoomDto}
                      chatRowOptionsElement={messageOptionsMenu(
                        index,
                        message,
                        true,
                        UtilServices.isMobileDevice(),
                      )}
                      currentlyActiveOoniChatMsg={currentlyActiveOoniChatMsg}
                      mentorDto={roomExtendedMentorDto?.mentorDto}
                      senderObjectId={props.myParticipantId}
                      senderObjectType={props.myParticipantType}
                      getTextMessage={props.getTextMessage}
                    />
                  )}
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.HANDOFF_FLOW_START && (
                    <AiHandoffStartedChatMsgComponent
                      chatMessageDto={message}
                      chatRoomDto={props.chatRoomDto}
                      chatRowOptionsElement={messageOptionsMenu(
                        index,
                        message,
                        true,
                        UtilServices.isMobileDevice(),
                      )}
                      mentorDto={roomExtendedMentorDto?.mentorDto}
                      senderObjectId={props.myParticipantId}
                      senderObjectType={props.myParticipantType}
                      getTextMessage={props.getTextMessage}
                    />
                  )}
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.HANDOFF_PENDING && (
                    <AiHandoffPendingChatMsgComponent
                      isDisabled={
                        props.chatRoomDto.taskOwnerMentorId ||
                        !showTakeOwnershipBtn
                      }
                      isTakeOwnershipFlowRunning={
                        props.isTakeOwnershipFlowRunning
                      }
                      chatMessageDto={message}
                      chatRowOptionsElement={messageOptionsMenu(
                        index,
                        message,
                        true,
                        UtilServices.isMobileDevice(),
                      )}
                      mentorDto={roomExtendedMentorDto?.mentorDto}
                      getTextMessage={props.getTextMessage}
                      onTakeOwnershipBtnClick={onTakeOwnershipBtnClick}
                    />
                  )}
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.TASK_OWNER_EVENT && (
                    <ChatRoomTaskOwnerComponent
                      isDisabled
                      chatMessageDto={message}
                      chatRowOptionsElement={messageOptionsMenu(
                        index,
                        message,
                        true,
                        UtilServices.isMobileDevice(),
                      )}
                      senderObjectId={props.myParticipantId}
                      senderObjectType={props.myParticipantType}
                      widgetDto={widgetDto}
                    />
                  )}
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.NOTES_MESSAGE && (
                    <React.Fragment>
                      <div
                        className={`et-chatting-chat-row-span-private-note-heading ${
                          props.isTeamChatRoom &&
                          props.chatRoomDto.participantsInfo[
                            message.senderObjectId
                          ]?.isMe
                            ? 'et-chatting-chat-row-span-private-note-heading-me'
                            : ''
                        }`}>
                        <TitleComponentV2
                          titleTxt={`${props.isGroupChatRoom || props.isTeamChatRoom ? 'Team' : 'Private'} Note${
                            props.isGroupChatRoom || props.isTeamChatRoom
                              ? ` - Saved by ${participantName}`
                              : ''
                          }`}
                          toolTipPosition="bottom"
                          toolTipTxt={
                            props.isTeamChatRoom
                              ? 'This is not visible to the customers but your team can see it'
                              : 'Only you can see this'
                          }
                        />
                      </div>
                      <span className="et-chatting-chat-row-span-notes">
                        {props.getTextMessage(message.messageText)}
                      </span>
                      <div className="et-chat-status">
                        <span className="et-time">{formattedDate}</span>
                      </div>
                    </React.Fragment>
                  )}
                </div>
                {message.subType ===
                  VIDABOO_CONSTANTS.CHAT_SUBTYPES.OB_EMAIL && (
                  <React.Fragment>
                    <div className="et-chat-left-special-item-schedule-v2">
                      {message.parsedMetaData && (
                        <div className="et-chat-n-left-info-msg-wrap">
                          <div className="et-chat-txt-form">
                            <div className="et-cci-img-wrap ">
                              <EnvelopeArrowIcon fillColor="#2961fa" />
                            </div>
                            Outbound Email
                          </div>
                          <React.Fragment key={index}>
                            <div className="et-chat-clim-item">
                              <div className="et-chat-item-title">
                                {'Subject:'}
                              </div>
                              <div className="et-chat-item-answer">
                                {message.parsedMetaData.subject}
                              </div>
                            </div>
                            <div className="et-chat-clim-item">
                              <div className="et-chat-item-title">
                                {'Content:'}
                              </div>
                              <div className="et-chat-item-answer">
                                {message.parsedMetaData.content}
                              </div>
                            </div>
                          </React.Fragment>
                        </div>
                      )}
                    </div>
                    <div className="et-chat-status">
                      <span className="et-time">{formattedDate}</span>
                    </div>
                  </React.Fragment>
                )}
                {!isMsgSendByOoni && (
                  <div
                    className={
                      message.subType ===
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.TEXT_MESSAGE
                        ? 'et-chatting-chat-row-options-text-message'
                        : message.subType ===
                            VIDABOO_CONSTANTS.CHAT_SUBTYPES.NOTES_MESSAGE
                          ? 'et-chatting-chat-row-options-peer-note'
                          : ''
                    }>
                    {messageOptionsMenu(
                      index,
                      message,
                      true,
                      UtilServices.isMobileDevice(),
                    )}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <React.Fragment
              key={message.chatMessageId + '_' + message.sendTime}>
              <div
                onMouseEnter={(e) => doWhenMouseHoveredOnMessage(e, index)}
                onMouseLeave={doWhenMouseLeavesMessage}
                id={message.chatMessageId}
                className={
                  message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.MONEY_TRANSACTION ||
                  message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.AUDIO_MESSAGE ||
                  message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.NOTES_MESSAGE ||
                  message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.FILE_MESSAGE ||
                  message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.VIDEO_RECORDING ||
                  message.subType ==
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.SESSION_INSTANCE ||
                  message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.IMAGE_MESSAGE ||
                  message.subType === VIDABOO_CONSTANTS.CHAT_SUBTYPES.OB_EMAIL
                    ? `et-chatting-chat-row et-chat-right-no-back ${
                        message.subType ===
                        VIDABOO_CONSTANTS.CHAT_SUBTYPES.MONEY_TRANSACTION
                          ? 'et-chatting-chat-money-transaction'
                          : ''
                      } ${
                        message.subType ===
                        VIDABOO_CONSTANTS.CHAT_SUBTYPES.NOTES_MESSAGE
                          ? 'et-chatting-chat-private-note'
                          : ''
                      } ${
                        message.subType ===
                        VIDABOO_CONSTANTS.CHAT_SUBTYPES.FILE_MESSAGE
                          ? 'et-chatting-chat-file-message'
                          : ''
                      } ${
                        message.subType ===
                        VIDABOO_CONSTANTS.CHAT_SUBTYPES.SESSION_INSTANCE
                          ? 'et-chatting-session-instance-message'
                          : ''
                      }`
                    : 'et-chatting-chat-row et-chat-right '
                }>
                <div
                  className={`et-chatting-sender-message-wrapper ${
                    message.subType ===
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.TEXT_MESSAGE &&
                    'et-chatting-sender-message-wrapper-text_message'
                  }`}>
                  {
                    // message.subType !==
                    //   VIDABOO_CONSTANTS.CHAT_SUBTYPES.TEXT_MESSAGE &&
                    // message.subType !==
                    //   VIDABOO_CONSTANTS.CHAT_SUBTYPES.NOTES_MESSAGE &&
                    <div
                      className={
                        message.subType ===
                        VIDABOO_CONSTANTS.CHAT_SUBTYPES.NOTES_MESSAGE
                          ? 'et-chatting-sender-message-notes-options-wrapper'
                          : message.subType !==
                              VIDABOO_CONSTANTS.CHAT_SUBTYPES.TEXT_MESSAGE
                            ? 'et-chatting-sender-message-options-wrapper'
                            : 'et-chatting-sender-message-text-options-wrapper'
                      }>
                      {messageOptionsMenu(
                        index,
                        message,
                        false,
                        message.subType ===
                          VIDABOO_CONSTANTS.CHAT_SUBTYPES.NOTES_MESSAGE ||
                          UtilServices.isMobileDevice(),
                      )}
                    </div>
                  }
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.AUDIO_MESSAGE && (
                    <React.Fragment>
                      <GetVoiceMsgComponent
                        align="right"
                        voiceMsgId={message.metaData}
                        chatMessageId={message.chatMessageId}
                      />
                    </React.Fragment>
                  )}
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.SESSION_INSTANCE && (
                    <SessionInstanceChatComponentLazy
                      chatMessageDto={message}
                      chatRoomDto={props.chatRoomDto}
                      isAccountManager={context.isAccountManager}
                      isGroupChatRoom={props.isGroupChatRoom}
                      isTeamChatRoom={props.isTeamChatRoom}
                      myParticipantId={props.myParticipantId}
                      myRoomExtendedMentorDto={myRoomExtendedMentorDto}
                      participantsInfo={props.chatRoomDto.participantsInfo}
                      roomExtendedMentorDto={roomExtendedMentorDto}
                      widgetDto={widgetDto}
                      expertHomeContext={props.expertHomeContext}
                    />
                  )}
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.VIDEO_RECORDING && ( // this has toe be removed later!!
                    <VideoMessageComponentWrapper
                      chatMessageDto={message}
                      currentUser={props.currentUser}
                      chatRoomDto={props.chatRoomDto}
                      peerEmail={
                        props.chatRoomDto?.chatRoomPeerInfoDto?.peerEmail
                      }
                    />
                  )}
                  {(message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.FILE_MESSAGE ||
                    message.subType ===
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.IMAGE_MESSAGE) && (
                    <React.Fragment>
                      <GetFileMessageComponent
                        mediaMessageMeta={message.metaData}
                        align={'right'}
                        key={message.sendTime}
                        chatMessageId={message.chatMessageId}
                        setDataForImagePopup={setDataForImagePopup}
                      />
                    </React.Fragment>
                  )}
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.TEXT_MESSAGE && (
                    <span className="et-chatting-chat-row-span">
                      {props.getTextMessage(message.messageText)}
                    </span>
                  )}
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.MONEY_TRANSACTION && (
                    <React.Fragment>
                      <C2cMoneyTransactionChatComponent
                        align="right"
                        chatMessageDto={message}
                      />
                      <div className="et-chat-status">
                        <span className="et-time">{formattedDate}</span>
                      </div>
                    </React.Fragment>
                  )}
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.NOTES_MESSAGE && (
                    <div className="et-chatting-sender-notes-wrapper">
                      <div
                        className={`et-chatting-chat-row-span-private-note-heading ${props.isTeamChatRoom ? 'et-chatting-chat-row-span-private-note-heading-me' : ''}`}>
                        <TitleComponentV2
                          titleTxt={
                            props.isTeamChatRoom
                              ? 'Team Note - Saved by you'
                              : 'Private Note'
                          }
                          toolTipPosition="bottom"
                          toolTipTxt={
                            props.isTeamChatRoom
                              ? 'This is not visible to the customers but your team can see it'
                              : 'Only you can see this'
                          }
                        />
                      </div>
                      <span className="et-chatting-chat-row-span-notes">
                        {props.getTextMessage(message.messageText)}
                      </span>
                    </div>
                  )}
                  {message.subType ===
                    VIDABOO_CONSTANTS.CHAT_SUBTYPES.OB_EMAIL && (
                    <React.Fragment>
                      <div className="et-chat-left-special-item-schedule-v2">
                        {message.parsedMetaData && (
                          <div className="et-chat-n-right-info-msg-wrap">
                            <div className="et-chat-txt-form">
                              <div className="et-cci-img-wrap ">
                                <EnvelopeArrowIcon fillColor="#2961fa" />
                              </div>
                              Outbound Email
                            </div>
                            <React.Fragment key={index}>
                              {/* <div className="et-chat-clim-item">
                            <div className="et-chat-item-title">
                              {'Recipient Email:'}
                            </div>
                            <div className="et-chat-item-answer">
                              {message.parsedMetaData.recipientEmail}
                            </div>
                          </div> */}
                              {/* <div className="et-chat-separator" /> */}

                              <div className="et-chat-clim-item">
                                <div className="et-chat-item-title">
                                  {'Subject:'}
                                </div>
                                <div className="et-chat-item-answer">
                                  {message.parsedMetaData.subject}
                                </div>
                              </div>
                              <div className="et-chat-clim-item">
                                <div className="et-chat-item-title">
                                  {'Content:'}
                                </div>
                                <div className="et-chat-item-answer">
                                  {message.parsedMetaData.content}
                                </div>
                              </div>
                            </React.Fragment>
                          </div>
                        )}
                      </div>
                      <div className="et-chat-status">
                        <span className="et-time">{formattedDate}</span>
                      </div>
                    </React.Fragment>
                  )}
                </div>
                <div
                  className={`et-chat-status ${
                    message.subType ===
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.NOTES_MESSAGE &&
                    'et-chat-status-notes'
                  } ${
                    message.subType ===
                      VIDABOO_CONSTANTS.CHAT_SUBTYPES.VIDEO_RECORDING &&
                    'et-video-status'
                  }`}>
                  {message.subType !== 'notes' && message.messageWasRead && (
                    <React.Fragment>
                      <i className="et-chat-status-icon fas fa-check" />
                      <i className="et-chat-status-icon fas fa-check" />
                    </React.Fragment>
                  )}
                  <span className="et-time">{formattedDate}</span>
                </div>
              </div>
            </React.Fragment>
          );
        })}

        {showVoiceMessageUploadingLoader && (
          <div
            className="et-chatting-chat-row  et-chat-right"
            style={{backgroundColor: '#2961fa2a', padding: 5}}>
            <VoiceMsgUploadingLoader />
          </div>
        )}
        {props.peerIsTyping && (
          <div className="et-chat-peer-typing-container">
            <TypingComponent
              isMentor
              showMultipleUserUI={props.isGroupChatRoom || props.isTeamChatRoom}
              participantsInfo={props.chatRoomDto.participantsInfo}
              typingParticipantsInfo={Object.values(
                props.typingParticipantsInfoObj,
              )}
            />
          </div>
        )}
      </div>
      {popupType === POPUP_TYPES.MOVE_CHAT && (
        <MoveChatPopup
          chatRoom={props.chatRoomDto}
          formTitle="Assign to agent"
          onCancel={() => updatePopupType(null)}
          onTransition={(transitionChatRoomCloneRecipe) => {
            onTransitionToMentorChat(
              props.myParticipantId,
              transitionChatRoomCloneRecipe,
            );
            updatePopupType(null);
          }}
        />
      )}
      {/* Here will be Notes Popup */}
      {popupType === POPUP_TYPES.NOTES && (
        <MentorNotes
          isTeamChatRoom={props.isTeamChatRoom}
          notesValue={personalNotes[props.peerUserId]}
          handleChange={handlePersonalNoteChange}
          handleClose={() => updatePopupType(null)}
          onSaveNote={savePersonalNote}
        />
      )}
      {popupType === POPUP_TYPES.THREED && !threedFilePresent && (
        <ThreedMentorSelect
          handleClose={openClose3DRequestPopup}
          startThreedWithPeer={props.startThreedWithPeer}
          peerUserId={props.peerUserId}
          currentUser={props.currentUser}
          presentFile={presentFile}
          // handleChange={handlePersonalNoteChange}
          // defaultValue={personalNotes[props.peerUserId]}
          // onSaveNote={savePersonalNote}
        />
      )}
      {threedFilePresent && (
        <ThreedWrapper
          present3D={true}
          isMentor={true} // this is the mentor side.
          peerUserId={props.peerUserId}
          selected3DFile={selected3DFile}
          startThreedWithPeer={props.startThreedWithPeer}
          cancelPresent3d={cancelPresent3d}
          fileSettings={false}

          // handleClose={openClose3DRequestPopup}
          // startThreedWithPeer={props.startThreedWithPeer}
          // peerUserId={props.peerUserId}
          // currentUser={props.currentUser}
          // handleChange={handlePersonalNoteChange}
          // defaultValue={personalNotes[props.peerUserId]}
          // onSaveNote={savePersonalNote}
        />
      )}
      {/* Here the File drop popup */}
      {props.showSendFileComponent && (
        <SendFileComponent
          handleClose={() => {
            props.openCloseSendFileComponent();
            updatePopupType(null);
          }}
          currentSelectedFile={props.currentSelectedFile}
          onFileSelected={(file) => {
            const currentShowStatus =
              file == null
                ? !props.showSendFileComponent
                : props.showSendFileComponent;
            props.openCloseSendFileComponent(currentShowStatus, file);
            if (currentShowStatus) {
              updatePopupType(POPUP_TYPES.FILE);
            } else {
              updatePopupType(null);
            }
          }}
          sendMessage={props.sendMessage}
          senderObjectType={VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.MENTOR}
          senderObjectId={props.myParticipantId}
          roomId={props.chatRoomDto.roomId}
          headingText={'Send file'}
        />
      )}
      {/* Show Image popup */}
      {showImagePopup && (
        <ImageViewDownloadComponent
          src={srcImagePopup}
          fileName={meta.fileName}
          closeFunc={meta.onCancel}
          mediaMessageId={meta.mediaMessageId}
        />
      )}
      {props.showNewMsgPopup && (
        <div className="et-mentor-new-message-popup">
          <button
            className="et-mentor-popup-button"
            onClick={props.goToChatEnd}>
            New message arrived
          </button>
        </div>
      )}
      {isPermittedToWriteChatRoom && (
        <div className="et-share-payment">
          <ul className="et-chat-mentor-btns-ul">
            {!props.isGroupChatRoom &&
              !props.isTeamChatRoom &&
              props.callState === VIDABOO_CONSTANTS.VIDEO_CALL_STATE.INIT && (
                <li
                  className={`et-chat-mentor-btns ${
                    !props.isCustomerAvailableForInteraction
                      ? 'et-disable-mouse-cursor'
                      : ''
                  }`}>
                  {popupType === POPUP_TYPES.ENGAGER && (
                    <EngagerInitiatorComponent
                      context={context}
                      currentUser={props.currentUser}
                      mentorId={myRoomExtendedMentorDto.mentorDto.mentorId}
                      sessionMode={VIDABOO_CONSTANTS.SESSION_MODES.AUDIO_VIDEO}
                      peerUserId={props.peerUserId}
                      closeEngagerRequestPopup={() => updatePopupType(null)}
                    />
                  )}
                  <div
                    onClick={() => {
                      if (
                        props.isEngagerEnabled &&
                        props.isCustomerAvailableForInteraction
                      ) {
                        updatePopupType(POPUP_TYPES.ENGAGER);
                      }
                    }}
                    onMouseEnter={() => toggleTooltip('startVideoChat', true)}
                    onMouseLeave={() => toggleTooltip('startVideoChat', false)}>
                    {showTooltipComponent['startVideoChat'] && (
                      <ToolTipComponent
                        toolTipTxt={
                          !props.isEngagerEnabled
                            ? 'Active engager is disabled. Please contact your account admin to enable it.'
                            : props.isCustomerAvailableForInteraction
                              ? 'Invite to video chat'
                              : "We can't start a call as the customer is busy on another conversation"
                        }
                        toolTipPosition="top" // postion : top, right, bottom, left
                      />
                    )}
                    <i className="et-share-payment-icon fas fa-video" />
                    <span className="et-share-payment-span">Video</span>
                  </div>
                </li>
              )}
            {!props.isGroupChatRoom &&
              !props.isTeamChatRoom &&
              cfChatCenter?.disablePaymentRequest !== true &&
              moneyTransferEnabled && (
                <>
                  <li
                    className={`et-chat-mentor-btns ${
                      !props.isCustomerAvailableForInteraction
                        ? 'et-disable-mouse-cursor'
                        : ''
                    }`}>
                    {props.chatRoomDto && popupType === POPUP_TYPES.PAYMENT && (
                      <PaymentRequestInitiatorComponent
                        closePaymentPopup={() => updatePopupType(null)}
                        peerUserId={props.peerUserId}
                        chatRoomDto={props.chatRoomDto}
                      />
                    )}

                    <div
                      onClick={() => {
                        if (props.isCustomerAvailableForInteraction) {
                          updatePopupType(POPUP_TYPES.PAYMENT);
                        }
                      }}
                      onMouseEnter={() => toggleTooltip('requestPayment', true)}
                      onMouseLeave={() =>
                        toggleTooltip('requestPayment', false)
                      }>
                      <div className="et-share-payment-upgrade">
                        <UpgradeComponent
                          isCrown
                          billingPlanFeature={
                            VIDABOO_CONSTANTS.BILLING_PLAN_FEATURES
                              .MONEY_TRANSFER
                          }
                        />
                        <UpgradeComponent
                          billingPlanFeature={
                            VIDABOO_CONSTANTS.BILLING_PLAN_FEATURES
                              .MONEY_TRANSFER
                          }
                        />
                      </div>
                      {showTooltipComponent['requestPayment'] && (
                        <ToolTipComponent
                          toolTipTxt={
                            props.isCustomerAvailableForInteraction
                              ? 'Request payment'
                              : "We can't request for the payment as the customer is busy on another conversation"
                          }
                          toolTipPosition="top" // postion : top, right, bottom, left
                        />
                      )}
                      <i className="et-share-payment-icon fas fa-credit-card" />
                      <span className="et-share-payment-span">Payment</span>
                    </div>
                  </li>
                </>
              )}
            {false && (
              <li className="et-chat-mentor-btns">
                <i className="et-share-payment-icon fas fa-handshake" />
                <span className="et-share-payment-span">Let's Meet</span>
              </li>
            )}
            {!props.isGroupChatRoom &&
              !props.isTeamChatRoom &&
              props.callState === VIDABOO_CONSTANTS.VIDEO_CALL_STATE.INIT && (
                <li
                  className={`et-chat-mentor-btns ${
                    !props.isEngagerEnabled ||
                    !props.isCustomerAvailableForInteraction
                      ? 'et-disable-mouse-cursor'
                      : ''
                  }`}>
                  {popupType === POPUP_TYPES.SHARE && (
                    <div className="et-chat-mentor-screen-share-popup">
                      <EngagerInitiatorComponent
                        context={context}
                        currentUser={props.currentUser}
                        mentorId={myRoomExtendedMentorDto.mentorDto.mentorId}
                        sessionMode={
                          VIDABOO_CONSTANTS.SESSION_MODES.SCREEN_SHARE
                        }
                        peerUserId={props.peerUserId}
                        closeEngagerRequestPopup={() => updatePopupType(null)}
                      />
                    </div>
                  )}
                  <div
                    onClick={() => {
                      if (
                        props.isEngagerEnabled &&
                        props.isCustomerAvailableForInteraction
                      ) {
                        updatePopupType(POPUP_TYPES.SHARE);
                      }
                    }}
                    onMouseEnter={() => toggleTooltip('startScreenShare', true)}
                    onMouseLeave={() =>
                      toggleTooltip('startScreenShare', false)
                    }>
                    {showTooltipComponent['startScreenShare'] && (
                      <ToolTipComponent
                        toolTipTxt={
                          !props.isEngagerEnabled
                            ? 'Active engager is disabled. Please contact your account admin to enable it.'
                            : props.isCustomerAvailableForInteraction
                              ? 'Screen-sharing session'
                              : "We can't start a screen-sharing session as the customer is busy on another conversation"
                        }
                        toolTipPosition="top" // postion : top, right, bottom, left
                      />
                    )}
                    <div className="et-share-screen-payment-icon">
                      <img src={shareScreenIcon} alt="share-screen" />
                    </div>
                    <span className="et-share-payment-span">Share</span>
                  </div>
                </li>
              )}
            <li className="et-chat-mentor-btns">
              <div
                onClick={() => updatePopupType(POPUP_TYPES.NOTES)}
                onMouseEnter={() => toggleTooltip('showNotes', true)}
                onMouseLeave={() => toggleTooltip('showNotes', false)}>
                {showTooltipComponent['showNotes'] && (
                  <ToolTipComponent
                    toolTipTxt={'Start writing notes'}
                    toolTipPosition="top" // postion : top, right, bottom, left
                  />
                )}
                <div className="et-share-screen-payment-icon">
                  <img src={notesIcon} alt="notes" />
                </div>
                <span className="et-share-payment-span">Notes</span>
              </div>
            </li>
            {threedEnabled && (
              <li className="et-chat-mentor-btns">
                <div onClick={openClose3DRequestPopup}>
                  <div className="et-share-screen-payment-icon">
                    <img src={threedIcon} alt="3D" />
                  </div>
                  <span className="et-share-payment-span"> 3D Sense</span>
                </div>
              </li>
            )}
            {/* )} */}
            {!props.isTakeOwnershipFlowRunning && (
              <li className="et-chat-mentor-btns">
                <div
                  onClick={openCloseSendFileComponent}
                  onMouseEnter={() => toggleTooltip('sendFile', true)}
                  onMouseLeave={() => toggleTooltip('sendFile', false)}>
                  {showTooltipComponent['sendFile'] && (
                    <ToolTipComponent
                      toolTipTxt={'Send files'}
                      toolTipPosition="top" // postion : top, right, bottom, left
                    />
                  )}
                  <div className="et-share-screen-payment-icon">
                    <img src={fileSendIcon} alt="3D" />
                  </div>
                  <span className="et-share-payment-span">File</span>
                </div>
              </li>
            )}
            {!props.isGroupChatRoom && (
              <li className="et-chat-mentor-btns">
                <div
                  onClick={() => {
                    const messageToSend =
                      props.messageToSend ||
                      "Thank you for being a valued customer. We noticed you haven't visited our site in a while and wanted to check in. We miss you and have a special offer just for you.";
                    props.sendMessage(
                      messageToSend,
                      null,
                      null,
                      showSendEmailPopUp,
                      true,
                    );
                  }}
                  onMouseEnter={() => toggleTooltip('sendEmail', true)}
                  onMouseLeave={() => toggleTooltip('sendEmail', false)}>
                  {showTooltipComponent['sendEmail'] && (
                    <ToolTipComponent
                      toolTipTxt={'Send message via email'}
                      toolTipPosition="top"
                    />
                  )}
                  <div className="et-send-email-icon">
                    <img src={emailIcon} alt="email" />
                  </div>
                  <span className="et-share-payment-span">Email</span>
                </div>
              </li>
            )}
          </ul>
        </div>
      )}
      <div
        className={`et-chetting-keyborad ${showTakeOwnershipBtn ? 'et-chatting-keyboard-with-take-ownership-btn' : ''}`}>
        {props.expertHomeContext.showMentorPills && myRoomExtendedMentorDto && (
          <div className="et-mentor-chat-box-mentor-pill-wrap">
            <MentorPillComponent
              widgetName={widgetName}
              extendedMentorDto={myRoomExtendedMentorDto}
              toolTipPosition="top"
            />
          </div>
        )}
        <textarea
          disabled={
            props.isTakeOwnershipFlowRunning ||
            !props.isCustomerAvailableForInteraction ||
            !isPermittedToWriteChatRoom
          }
          ref={props.chatTextAreaRef}
          dir="auto"
          className="et-chetting-keyborad-input"
          rows="1" // sets default number of rows
          onChange={props.onTextareaChange}
          value={props.messageToSend}
          type="text"
          onKeyDown={props.onKeyDown}
          onBlur={props.sendUserStoppedTyping}
          placeholder={
            props.isTakeOwnershipFlowRunning
              ? 'Please wait till ownership is changed'
              : !isPermittedToWriteChatRoom
                ? isPermittedToReadChatRoom
                  ? "You don't have the necessary permissions to write in this room."
                  : 'View-only mode: this chat is managed by another agent.'
                : props.isCustomerAvailableForInteraction
                  ? 'Say something...'
                  : 'Customer is busy or chatting with another agent.'
          }
        />
        {!props.isTakeOwnershipFlowRunning &&
          isPermittedToWriteChatRoom &&
          props.isCustomerAvailableForInteraction && (
            <div className="et-smiley-record-send">
              <i
                onClick={props.handleEmojiBox}
                className="et-smiley-send-icon far fa-smile-beam"
              />

              <SendVoiceMsgComponent
                senderObjectType={
                  VIDABOO_CONSTANTS.CHAT_PARTICIPANT_TYPES.MENTOR
                }
                senderObjectId={props.myParticipantId}
                chatRoomId={props.chatRoomDto && props.chatRoomDto.roomId}
                sendAudioMessageNotification={
                  props.sendAudioMessageNotification
                }
                isMentor={true}
                sendGA={props.sendGA}
                showUploadingLoader={() => {
                  setShowVoiceMessageUploadingLoader(true);
                  props.goToChatEnd();
                }}
                hideUploadingLoader={() => {
                  setShowVoiceMessageUploadingLoader(false);
                }}
              />

              <i
                className="et-smiley-send-icon fas fa-arrow-right"
                onClick={() =>
                  props.sendMessage(
                    props.messageToSend,
                    null,
                    null,
                    showSendEmailPopUp,
                  )
                }
              />
            </div>
          )}
      </div>
      {showTakeOwnershipBtn && (
        <>
          <div
            className={`et-take-chat-control-btn ${showTakeControlInfo ? 'et-take-chat-control-btn-without-margin-bottom' : ''}`}>
            <MultiStateButton
              showSpinner={props.isTakeOwnershipFlowRunning}
              isPrimaryBtn
              btnTxt="Take control of the conversation"
              onClick={onTakeOwnershipBtnClick}
            />
          </div>
          {showTakeControlInfo && (
            <div className="et-mentor-cht-box-take-control-info-wrap">
              <InfoComponentV2
                btnTxt="Got it"
                subTitleTxt="You can can take control on this conversation and give back the control to AI in any time"
                onClick={handleTakeControlInfoDismiss}
              />
            </div>
          )}
        </>
      )}
      {showGiveBackControlBtn && (
        <div className="et-give-back-chat-control-btn-wrapper">
          <div className="et-give-back-chat-control-btn">
            <MultiStateButton
              showSpinner={props.isTakeOwnershipFlowRunning}
              btnTxt={
                isOoniEnabledForMentor
                  ? 'Hand back to ' +
                    utilsService.getAssistantName(
                      roomExtendedMentorDto?.mentorDto?.appControlDto
                        ?.assistantName,
                    )
                  : 'Release ownership of the conversation'
              }
              leftImage={
                isOoniEnabledForMentor ? (
                  <div className="et-gbcc-ai-bot-icon">
                    <NotificationAiBotIcon />
                  </div>
                ) : null
              }
              toolTipTxt={`Releases the ownership of the conversation back to ${isOoniEnabledForMentor ? 'Ooni.' : 'the system so that other agents can take over.'}`}
              onClick={onGiveBackControlBtnClick}
            />
          </div>
          <div className="et-gbcc-lock-btn-wrap">
            <MultiStateButton
              leftImage={
                <div className="et-gbcc-lock-btn">
                  {isTaskOwnerLocked ? (
                    <LockIcon fillColor="#2D2756" />
                  ) : (
                    <UnlockIcon />
                  )}
                </div>
              }
              toolTipPosition="top"
              toolTipTxt={
                isTaskOwnerLocked
                  ? `The conversation is locked in your control. ${isOoniEnabledForMentor ? 'Ooni will not take over automatically' : 'It will not be released'}, even after two hours of inactivity.`
                  : `${isOoniEnabledForMentor ? 'Ooni will take over automatically if the conversation is inactive for 2 hours.' : 'The conversation will be released automatically after two hours of inactivity.'}`
              }
              onClick={onToggleTaskOwnerLock}
            />
          </div>
        </div>
      )}
    </React.Fragment>
  );
};
export default withExpertHomeContext(MentorChatBoxComponent);
